<template>
  <div class="h-screen flex flex-col overflow-hidden">
    <div class="flex-1 flex flex-col">
      <header class="bg-background p-6">
        <div
          class="flex flex-col md:flex-row md:items-center justify-between gap-4"
        >
          <div>
            <h1 class="text-2xl font-semibold tracking-tight">
              Digital Price Displays
            </h1>
            <p class="text-muted-foreground">
              Manage your e-ink price tags and digital displays.
            </p>
          </div>
          <!-- <div class="flex items-center gap-2">
            <el-button
              type="primary"
              icon="el-icon-plus"
              @click="handlePrimaryAction"
            >
              Add Display
            </el-button>
          </div> -->
        </div>
      </header>
      <div class="flex-1 flex flex-col p-6">
        <div class="flex-1 flex flex-col">
          <DisplaysList
            v-if="tabId === 'displays'"
            class="flex-1"
            :searchText="searchText"
            @create="handlePrimaryAction">
            <TabsDigitalDisplays v-model="tabId" />
          </DisplaysList>

          <ProductsList
            v-else-if="tabId === 'product'"
            class="flex-1"
            :searchText="searchText"
            ref="productsListRef">
            <TabsDigitalDisplays v-model="tabId" />
          </ProductsList>

          <TemplatesLibrary
            v-else-if="tabId === 'templates'"
            class="flex-1"
            :searchText="searchText"
            @import="handlePrimaryAction">
            <TabsDigitalDisplays v-model="tabId" />
          </TemplatesLibrary>

          <SchedulesBoard
            v-else-if="tabId === 'schedules'"
            class="flex-1"
            :searchText="searchText"
            @create="handlePrimaryAction">
            <TabsDigitalDisplays v-model="tabId" />
          </SchedulesBoard>
          
          <AiPricingView v-else class="flex-1" @refresh="handlePrimaryAction">
            <TabsDigitalDisplays v-model="tabId" />
          </AiPricingView>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DisplayStatsPanel from "./DisplayStatsPanel.vue";
import TabsDigitalDisplays from "./TabsDigitalDisplays.vue";
import DisplaysList from "./DisplaysList.vue";
import ProductsList from "./ProductsList.vue";
import TemplatesLibrary from "./TemplatesLibrary.vue";
import SchedulesBoard from "./SchedulesBoard.vue";
import AiPricingView from "./AiPricingView.vue";

export default {
  name: "DigitalDisplaysPage",
  components: {
    DisplayStatsPanel,
    TabsDigitalDisplays,
    DisplaysList,
    ProductsList,
    TemplatesLibrary,
    SchedulesBoard,
    AiPricingView,
  },
  data() {
    return {
      tabId: "displays",
      searchText: "",
    };
  },
  methods: {
    async handlePrimaryAction(item) {
      const result = await this.$loaderWindow({
        title: `Edit Display`,
        component: () => import("./EditDisplay.vue"),
        width: "50%",
        showHeader: false,
        padding: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        props: { item },
      });
    },
    async handleAddProduct() {
      await this.$refs.productsListRef.onEditProduct();
    },
  },
};
</script>
